import {Link} from 'react-router-dom'

import {RiHeartAddLine} from 'react-icons/ri'

import CartContext from '../../context/CartContext'

import './index.css'

const ProductCard = props => (
  <CartContext.Consumer>
    {value => {
      const {addWishList} = value

      const {productData} = props
      const {title, brand, imageUrl, rating, price, id} = productData

      const onClickWishList = () => {
        addWishList(productData)
      }

      return (
        <li className="product-item">
          <Link to={`/products/${id}`} className="link-item">
            <img src={imageUrl} alt="product" className="thumbnail" />
            <h1 className="title">{title}</h1>
            <p className="brand">by {brand}</p>
            <div className="product-details">
              <p className="price">Rs {price}/-</p>
              <div className="rating-container">
                <p className="rating">{rating}</p>
                <img
                  src="https://assets.ccbp.in/frontend/react-js/star-img.png"
                  alt="star"
                  className="star"
                />
              </div>
            </div>
          </Link>
          <div className="life">
            <button
              type="button"
              aria-labelledby="button-label"
              className="life-button"
              onClick={onClickWishList}
            >
              <RiHeartAddLine size={25} />
            </button>
          </div>
        </li>
      )
    }}
  </CartContext.Consumer>
)
export default ProductCard
